import {Chacra, ZonaExclusion} from "src/app/chacra-core";

export class MapPopupData {
  item: Chacra | ZonaExclusion;
  attrId: string;
  type: string;
}
